import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import React from "react";
import { ButtonLeft, ButtonRight } from "./index";
import { alpha, styled, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { getLanguage } from "../../../helper-functions/getLanguage";
import PrevIcon from "../../icons/PrevIcon";
import NextIcon from "../../icons/NextIcon";
import { getCurrentModuleType } from "../../../helper-functions/getCurrentModuleType";
import Slider from "react-slick";
import FeaturedItemCard from "./card";
import PharmacyCategoryCard from "../../cards/PharmacyCategoryCard";
import { WhiteNext, WhitePrev } from "../visit-again/SliderSettings";
import { ModuleTypes } from "../../../helper-functions/moduleTypes";

const ButtonContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isdisabled',
})(({ theme, right, isdisabled }) => ({
  top: 0,
  height: "100%",
  width: "73px",
  background:
    right === "true"
      ? theme.direction === "ltr"
        ? `linear-gradient(270deg, ${theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.95) : theme.palette.neutral[100]} 0%, ${alpha(theme.palette.background.paper, 0)} 100%)`
        : `linear-gradient(270deg, ${alpha(theme.palette.background.paper, 0)} 0%, ${theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.95) : theme.palette.neutral[100]} 100%)`
      : theme.direction === "ltr"
      ? `linear-gradient(to right, ${theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.95) : theme.palette.neutral[100]} 0%, ${alpha(theme.palette.background.paper, 0)} 100%)`
      : `linear-gradient(to left, ${alpha(theme.palette.background.paper, 0)} 0%, ${theme.palette.mode === 'dark' ? alpha(theme.palette.background.paper, 0.95) : theme.palette.neutral[100]} 100%)`,

  zIndex: 1,
  right: right === "true" && 0,
  left: right !== "true" && 0,
  position: "absolute",
  alignItems: "center",
  justifyContent: "center",
  display: isdisabled ? "none" : "flex",
}));
const PrevWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isdisabled',
})(({ theme, isdisabled }) => ({
  zIndex: 1,
  top: "50%",
  left: 0,
  display: isdisabled ? "none" : "flex",
  backgroundColor: theme.palette.primary.main,
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));
const NextWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isdisabled',
})(({ theme, isdisabled }) => ({
  top: "50%",
  zIndex: 1,
  right: 8,
  display: isdisabled ? "none" : "flex",
  backgroundColor: theme.palette.primary.main,
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));
const Next = ({ onClick, className, displayNoneOnMobile }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  return (
    <ButtonContainer
      isdisabled={className?.includes("slick-disabled").toString()}
      right="true"
      sx={{
        display: displayNoneOnMobile && isMobile ? 'none !important' : undefined
      }}
    >
      <NextWrapper
        className={`client-nav client-next ${className}`}
        onClick={onClick}
        isdisabled={className?.includes("slick-disabled").toString()}
      >
        {getLanguage() === "rtl" ? <PrevIcon /> : <NextIcon />}
      </NextWrapper>
    </ButtonContainer>
  );
};
const Prev = ({ onClick, className, displayNoneOnMobile }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  return (
    <ButtonContainer
      isdisabled={className?.includes("slick-disabled").toString()}
      sx={{
        display: displayNoneOnMobile && isMobile ? 'none !important' : undefined
      }}
    >
      <PrevWrapper
        className={`client-nav client-prev ${className}`}
        onClick={onClick}
        isdisabled={className?.includes("slick-disabled").toString()}
      >
        {getLanguage() === "rtl" ? <NextIcon /> : <PrevIcon />}
      </PrevWrapper>
    </ButtonContainer>
  );
};

export const moduleWiseNext = () => {
  switch (getCurrentModuleType()) {
    case ModuleTypes.GROCERY:
      return <Next />;
    case ModuleTypes.PHARMACY:
      return <WhiteNext noboxshadow displayNoneOnMobile />;
    case ModuleTypes.ECOMMERCE:
      return <Next />;
    case ModuleTypes.FOOD:
      return <WhiteNext noboxshadow displayNoneOnMobile />;
    case ModuleTypes.LIQUOR:
      return <Next />;
    default:
      return <Next />;
  }
};
export const moduleWisePrev = () => {
  switch (getCurrentModuleType()) {
    case ModuleTypes.GROCERY:
      return <Prev />;
    case ModuleTypes.PHARMACY:
      return <WhitePrev noboxshadow />;
    case ModuleTypes.ECOMMERCE:
      return <Prev />;
    case ModuleTypes.FOOD:
      return <WhitePrev displayNoneOnMobile noboxshadow />;
    case ModuleTypes.LIQUOR:
      return <Prev />;
    default:
      return <Prev />;
  }
};

